import { create } from 'zustand';

const useAppInfoStore = create((set) => ({
  appInfo: null,
  setAppInfo: (appInfo) => set({ appInfo }),
}));

export default useAppInfoStore;
